import ModelUtil from '@leverege/model-util';
const TYPE = 'table.TableModel';
function create(extend) {
  return {
    type: TYPE,
    columns: [],
    selectable: true,
    ...extend
  };
}
export default {
  TYPE,
  create,
  ...ModelUtil.createAllArray('columns', 'Column', 'Columns'),
  ...ModelUtil.createAllValue('selectable', 'Selectable', undefined, {
    defaultValue: true
  })
};